import React from 'react';

import { COPIES } from '../../../../constants';

const TeamsLabel = () => <span className="nav-label">{COPIES.teamsLabel}</span>;

export default TeamsLabel;
